import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `font-heading font-bold text-base px-1 py-1 border-b-2 transition-colors duration-200 ${
      isActive
        ? "border-[#FF0000] text-black"
        : "border-transparent text-slate-700 hover:text-black hover:border-[#FBEF14]"
    }`;

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b-2 border-black/5">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-32 flex items-center justify-between">
        <Logo height={112} />

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"} data-testid={`nav-${l.label.toLowerCase()}`} className={linkClass}>
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/#coming-soon"
            data-testid="nav-coming-soon"
            className="relative font-heading font-bold text-base text-[#FF0000] hover:opacity-80 transition-opacity"
          >
            Coming Soon
            <span className="absolute -top-2 -right-3 w-2.5 h-2.5 rounded-full bg-[#FF0000] animate-pulse" />
          </Link>
          <NavLink
            to="/shop"
            data-testid="nav-shop-cta"
            className="inline-flex items-center min-h-[44px] rounded-full bg-[#FF0000] text-white font-bold px-6 hover:bg-[#d60000] hover:-translate-y-0.5 transition-all duration-200"
          >
            Shop the Books
          </NavLink>
          <Link
            to="/#learning-circle"
            data-testid="nav-waitlist-cta"
            className="inline-flex items-center min-h-[44px] rounded-full bg-[#00A000] text-white font-bold px-6 hover:bg-[#008800] hover:-translate-y-0.5 transition-all duration-200"
          >
            Join the Learning Circle
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 rounded-full hover:bg-black/5"
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-white border-t-2 border-black/5 px-4 py-4 flex flex-col gap-2" data-testid="mobile-menu">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-heading font-bold text-lg py-3 px-2 rounded-xl ${isActive ? "bg-[#FFFBF2] text-[#0000FF]" : "text-slate-800"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/#coming-soon"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-coming-soon"
            className="font-heading font-bold text-lg py-3 px-2 rounded-xl text-[#FF0000] flex items-center gap-2"
          >
            Coming Soon
            <span className="w-2.5 h-2.5 rounded-full bg-[#FF0000] animate-pulse" />
          </Link>
          <NavLink
            to="/shop"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-shop-cta"
            className="mt-2 inline-flex items-center justify-center min-h-[48px] rounded-full bg-[#FF0000] text-white font-bold px-6"
          >
            Shop the Books
          </NavLink>
          <Link
            to="/#learning-circle"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-waitlist-cta"
            className="inline-flex items-center justify-center min-h-[48px] rounded-full bg-[#00A000] text-white font-bold px-6"
          >
            Join the Learning Circle
          </Link>
        </div>
      )}
    </header>
  );
}
